import {
  PluginSubmitCreditDecisionRequest,
  PluginSubmitCreditDecisionResponse,
} from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runSubmitCreditDecisionRequest = (
  constructPost: ConstructPost,
  data: PluginSubmitCreditDecisionRequest,
): Promise<
  NonPaginatedResponse<PluginSubmitCreditDecisionResponse> | undefined
> =>
  constructPost<NonPaginatedResponse<PluginSubmitCreditDecisionResponse>>(
    `${PLUGIN_BASE_PATH}/submit-credit-decision-request`,
    { data },
    { preventDefaultErrorToast: true },
  );
